import { LOCAL, ROOT_FLAG } from "@/store/mutations";

const { SET_PAID_DEDUCTIBLE_AMOUNT } = LOCAL;

export default {
	namespaced: true,
	state: {
		amount: 0,
		paid: 0,
		parentId: false,
	},
	getters: {
		remaining: (state) => state.amount - state.paid,
		toPay: (state, getters) => (damage) => getters.calculate(getters.remaining, damage.cost),
		calculate: () => (remaining, cost) => Math.min(remaining, cost),
	},
	actions: {
		pay({ dispatch }, invoice) {
			dispatch("game/balance/withdraw", { amount: invoice.toPay }, ROOT_FLAG);
			dispatch("track", invoice);
		},
		track({ commit, state }, invoice) {
			const amount = state.paid + invoice.toPay;
			commit(SET_PAID_DEDUCTIBLE_AMOUNT, { amount });
		},
		reset({ commit }) {
			commit(SET_PAID_DEDUCTIBLE_AMOUNT, { amount: 0 });
		},
	},
	mutations: {
		[SET_PAID_DEDUCTIBLE_AMOUNT](state, payment) {
			state.paid = payment.amount;
		},
	},
};
